import React from 'react'
import { useTranslation } from 'react-i18next'
import { stringToLocationObject } from 'lib/location'
import cookies from 'lib/cookies'
import { debugLog } from 'lib/console'
import { getLocale } from 'lib/utils/getLocale'

import { Redirect } from 'react-router-dom'

const AuthLogoutCallbackHandler = () => {
    const { i18n } = useTranslation()

    const target = cookies.get('logoutSuccessTarget') || `${getLocale(i18n.language) || '/'}`

    debugLog('auth - AuthLogoutCallbackHandler - target:', target)

    return <Redirect to={stringToLocationObject(target)} />
}

export default AuthLogoutCallbackHandler
